import React from 'react';
import { Helmet } from 'react-helmet';
import { useAuth } from '../../contexts/AuthContext';
import RoleBasedNavigation from '../../components/navigation/RoleBasedNavigation';
import BrandHeader from './components/BrandHeader';
import LoginForm from './components/LoginForm';
import TrustSignals from './components/TrustSignals';
import RegistrationPrompt from './components/RegistrationPrompt';

const Login = () => {
  const { user, userProfile, isAuthenticated } = useAuth();

  return (
    <>
      <Helmet>
        <title>Sign In to BardPlay | Shakespeare Learning Platform</title>
        <meta name="description" content="Sign in to BardPlay and continue your Shakespeare learning journey. Access your personalized dashboard, track progress, and master the Bard's works." />
      </Helmet>
      
      <div className="min-h-screen flex flex-col animated-gradient-bg">
        <RoleBasedNavigation 
          user={{
            ...user,
            role: userProfile?.role,
            full_name: userProfile?.full_name,
            email: user?.email
          }} 
          isAuthenticated={isAuthenticated} 
        />
        <div className="flex-grow flex items-center justify-center p-4 md:p-8 pt-24 md:pt-32 lg:pt-36">
          <div className="w-full max-w-md space-y-8">
            <BrandHeader />
            <div className="bg-surface-dark/50 backdrop-blur-xl border border-border rounded-2xl shadow-2xl p-8">
              <LoginForm />
            </div>
            <RegistrationPrompt />
          </div>
        </div>
        <TrustSignals />
      </div>
    </>
  );
};

export default Login;